import moment from "moment"

export default {
    filters: {
        humanDate(date){
            if(moment().format('YYYYMMDD') == moment(date).format('YYYYMMDD')){
                // Today
                return 'Vandaag'
            } else if(moment().subtract(1, 'days').format('YYYYMMDD') == moment(date).format('YYYYMMDD')){
                // Yesterday
                return 'Gisteren'
            } else {
                return moment(date).format('DD-MM-YYYY')
            }
        },

        humanDateTime(date){
            if(moment().format('YYYYMMDD') == moment(date).format('YYYYMMDD')){
                // Today
                return 'Vandaag om '+moment(date).format('HH:mm')
            } else if(moment().subtract(1, 'days').format('YYYYMMDD') == moment(date).format('YYYYMMDD')){
                // Yesterday
                return 'Gisteren om '+moment(date).format('HH:mm')
            } else {
                if(moment(date).format('YYYY') == moment().format('YYYY')){
                    return moment(date).format('DD-MM')+' om '+moment(date).format('HH:mm')
                } else {
                    return moment(date).format('DD-MM-YYYY')+' om '+moment(date).format('HH:mm')
                }
            }
        },

        capitalize(string){
            if(string){
                return string.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase() })
            }
        }
    }
}